import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AlchemyProvider } from '@m/alchemy-ui/AlchemyProvider';
import SidePane from '../dig-components/side-pane';
import CustomParamsPane from '../CustomParamsPane';
import EmbeddedFormsPane from '../EmbeddedForms';
import ApplyChangesPane from '../ApplyChangesPane';
import { init } from '../../actions/appActions';
import { getFormId, isEmbeddedForm } from '../../services/onsiteService';
import './fonts.css';
import '../../fonts/OpenSans-Regular.ttf';
import { EmbeddedFormContainer } from '../EmbeddedForms/EmbeddedContainer';
import VersionToggle from '../VersionToggle';
import ModeToggle from '../ModeToggle';
import GlobalAppStyle from './StyledApp';
import DeviceToggle from '../DeviceToggle';
import { DeviceContainer } from '../DeviceContainer/DeviceContainer';

export class App extends Component {

  componentDidMount() {
    this.props.dispatch(init());
  }

  isShowEmbeddedPane() {
    const formId = getFormId();
    return isEmbeddedForm(formId);
  }

  render() {
    const embeddedPane = this.isShowEmbeddedPane() ? <EmbeddedFormsPane /> : null;
    const embeddedFormContainer = this.isShowEmbeddedPane() ? <EmbeddedFormContainer /> : null;
    const beenUpdatedToFormV2 = this.props.app.provisions['21dcr2_MPC2743_enable_newLiveForm'];
    const deviceType = this.props.app.deviceType;
    return (
      <AlchemyProvider>
        <GlobalAppStyle />
      <div className="App">
        {embeddedFormContainer}
        <div id="md-iframe-container" className={deviceType}>
          <DeviceContainer deviceType={deviceType} />
        </div>
        <div>
          <SidePane>
            {embeddedPane}
            <CustomParamsPane />
            <ApplyChangesPane />
          </SidePane>
          {
            this.props.app.isShowToggle && !beenUpdatedToFormV2 && <VersionToggle versionToPresent={this.props.app.versionToPresent} />
          }
          <ModeToggle />
          <DeviceToggle />
        </div>
      </div>
      </AlchemyProvider>
    );
  }
}
export default connect(state => ({ app: state.app }))(App);
